import { apiUrl, type FileDto } from '../lib/api';
import { formatBytes, formatRemaining, savings, sourceLabel } from '../lib/format';

interface Props {
  files: FileDto[];
  now: number;
  onDelete: (id: string) => void;
  onDownload: (file: FileDto) => void;
}

export function FileList({ files, now, onDelete, onDownload }: Props) {
  return (
    <div>
      {files.map((file) => (
        <FileRow key={file.id} file={file} now={now} onDelete={onDelete} onDownload={onDownload} />
      ))}
    </div>
  );
}

function FileRow({
  file,
  now,
  onDelete,
  onDownload,
}: {
  file: FileDto;
  now: number;
  onDelete: (id: string) => void;
  onDownload: (file: FileDto) => void;
}) {
  const failed = file.status === 'failed';
  const saved = savings(file.originalBytes, file.outputBytes);

  return (
    <div className={'file-row' + (failed ? ' is-failed' : '')}>
      {failed ? (
        <div className="thumb thumb-placeholder" aria-hidden="true">
          ⚠️
        </div>
      ) : (
        <img
          className="thumb"
          src={apiUrl('/api/files/' + file.id + '/thumb?t=' + encodeURIComponent(file.token))}
          alt=""
          loading="lazy"
          width={52}
          height={52}
        />
      )}

      <div className="file-meta">
        <div className="file-name" title={failed ? file.originalName : file.outputName}>
          {failed ? file.originalName : file.outputName}
        </div>
        <div className="file-sub">
          {failed ? (
            <span className="error">{file.error ?? 'Conversion failed'}</span>
          ) : (
            <>
              {file.width} × {file.height} · {formatBytes(file.outputBytes)}
              {saved !== null ? <span className="saving"> · {saved}% smaller</span> : null}
              {' · '}
              {sourceLabel(file.source)} · deleted in {formatRemaining(file.expiresAt, now)}
            </>
          )}
        </div>
      </div>

      <div className="file-actions">
        {!failed ? (
          <button type="button" className="btn btn-quiet btn-sm" onClick={() => onDownload(file)}>
            Download
          </button>
        ) : null}
        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() => onDelete(file.id)}
          aria-label={'Remove ' + file.originalName}
          title="Remove now"
        >
          Remove
        </button>
      </div>
    </div>
  );
}
